import type { ErrorResponse } from '~/types/error-responses.types';
import BaseException from './BaseException';

export default class JSONParseErrorException extends BaseException {
  readonly name = 'JSONParseErrorException';

  constructor(response?: ErrorResponse<any>) {
    super({
      errors: [
        {
          description: 'web.error.could_not_parse_json',
        },
      ],
      ...response,
    });
  }
}
